/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Timeline_EmptyInputs */

const en_case_detail_timeline_empty = /** @type {(inputs: Case_Detail_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity recorded yet.`)
};

const pt_br2_case_detail_timeline_empty = /** @type {(inputs: Case_Detail_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade registrada.`)
};

/**
* | output |
* | --- |
* | "No activity recorded yet." |
*
* @param {Case_Detail_Timeline_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_timeline_empty = /** @type {((inputs?: Case_Detail_Timeline_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Timeline_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_timeline_empty(inputs)
	return pt_br2_case_detail_timeline_empty(inputs)
});